import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { AddEdit } from './AddEdit';
import { AddEditDireccion } from './AddEditDireccion';

import { List } from "./List";

function Clientes({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/edit/:id`} component={AddEdit} />
            <Route path={`${path}/direccion/add/:cliente`} component={AddEditDireccion} />
            <Route path={`${path}/direccion/:id`} component={AddEditDireccion} />
            
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    );
}


export { Clientes };

//export default Sucurs;